<script>
export default{
  props: {
    modelValue: Boolean,
    soalStats: Object,
    cekSelesai: Function,
  },

  emits: ['update:modelValue'],

  methods: {
    closeModal() {
      this.$emit('update:modelValue', false);
    },
  },
}
</script>

<template>
  <transition name="fade-modal">
    <div v-if="modelValue" class="custom-modal-overlay" @click.self="closeModal()">
      <div class="custom-modal">
        <!-- Header -->
        <div class="modal-header-custom">
          <div class="icon-warning">⚠️</div>
          <h5>Informasi Pengerjaan</h5>
          <span class="close-btn" @click="closeModal()">×</span>
        </div>

        <!-- Body -->
        <div class="modal-body-custom">
          <p v-if="soalStats.answered === soalStats.total">
            Semua soal telah dijawab. Apakah Anda yakin ingin menyimpan jawaban?
          </p>
          <p v-else>
            Anda masih memiliki
            <span class="text-warning">{{ soalStats.unanswered }} soal</span>
            yang belum dijawab.
          </p>

          <!-- Progress Box -->
          <div class="progress-box">
            <div class="d-flex justify-content-between mb-1">
              <span>Soal Terjawab</span>
              <strong>{{ soalStats.answered }} / {{ soalStats.total }}</strong>
            </div>

            <!-- YOUR EXISTING PROGRESS BAR -->
            <div class="mym-progress-bar">
              <div
                class="mym-progress-fill"
                :style="{ width: soalStats.progress + '%' }"
              ></div>
            </div>
          </div>

          <small class="text-muted">
            Setelah mengirim, Anda tidak dapat mengubah jawaban.
          </small>
        </div>

        <!-- Footer -->
        <div class="modal-footer-custom">
          <button
            v-if="soalStats.answered !== soalStats.total"
            class="btn btn-secondary"
            @click="closeModal()"
          >
            Kembali
          </button>
          <button
            v-if="soalStats.answered === soalStats.total"
            class="btn btn-success"
            @click="cekSelesai()"
          >Kirim</button>
        </div>
      </div>
    </div>
  </transition>
</template>